import React from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import ProductForm from './ProductForm';

const CreateProductModal = ({isOpen, toggle, refreshList}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false} centered={true}>
            <ModalHeader toggle={toggle}>
                <strong>Create Product</strong>
            </ModalHeader>
            <ProductForm
                type="create"
                toggle={toggle}
                refreshList={refreshList}
            />
        </Modal>
    );
};

export default CreateProductModal;
